module.exports = __webpack_public_path__ + "img/homepageBannerJapanese.d7b99da0.jpg";